import { FC, useEffect, useState} from 'react';
import { Button } from "@tennr/frontend/components/Button";
import { Link } from "@tanstack/react-router";

export const AshbySection:FC = () => {
    const [data, setData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<any>();

    useEffect(() => {
        async function getTeams(){
            try {
                const response = await fetch('https://jobs.ashbyhq.com/api/non-user-graphql?op=ApiJobBoardWithTeams', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apollographql-client-name': 'frontend_non_user',
                        'apollographql-client-version': '0.1.0',
                    },
                    body: JSON.stringify({
                    operationName: "ApiJobBoardWithTeams",                    
                    variables: {
                        organizationHostedJobsPageName: "tennr",
                    },
                    query: `
                        query ApiJobBoardWithTeams($organizationHostedJobsPageName: String!) {
                            jobBoard: jobBoardWithTeams(organizationHostedJobsPageName: $organizationHostedJobsPageName) {
                                teams {
                                    name                                
                                }
                            }
                        }`,                
                    })
                });
                const json = await response.json()
                setData(json.data);
                setLoading(false);
                console.log(data)
            } catch (error) {
                setError(error);
                setLoading(false);
            }
        }
        getTeams();
        
    }, []);

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>Error: {error?.message}</div>;
        }
    return (
        <div className="career-links">                    
            {data?.jobBoard?.teams.map((team,ix) => (
                <Link to='https://jobs.ashbyhq.com/tennr' key={`link-${ix}`}>
                <Button backdropFilter="none" text={ team.name } iconPath="/svg/arrow-right.svg" iconPos="right" backgroundColorLight="#FBFBF9"
            backgroundColorDark="#FBFBF9"
            textColorLight="#5F4037"
            textColorDark="#5F4037" />
                </Link>
            ))}        
        </div>
    )
}